import { useState } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Flex, Heading, Button as RadixButton } from '@radix-ui/themes';
import { ToggleGroup } from '../../../shared/ToggleGroup/ToggleGroup';
import Button from '../../../shared/Button';
import { UploadFile } from './UploadFile.jsx';
import { ManageCategoriesModal } from './ManageCategories/ManageCategoriesModal.jsx';
import { VIEW_TYPES } from '../constants';

const BackArrow = styled.i`
  margin-right: 10px;
`;

export const VaultHeader = ({
  activeView,
  onViewToggle,
  organizationId,
  uploadFiles,
  categories,
  vendors,
  selectedCategory,
  onClearCategory,
}) => {
  const { t } = useTranslation('vault');
  const [manageOpen, setManageOpen] = useState(false);

  const showManageButton =
    activeView === VIEW_TYPES.CATEGORY && !selectedCategory;

  const viewToggleItems = [
    {
      value: VIEW_TYPES.CATEGORY,
      label: t('byCategory'),
      icon: 'fa-regular fa-grid-2',
    },
    {
      value: VIEW_TYPES.LIST,
      label: t('allFiles'),
      icon: 'fa-regular fa-list',
    },
  ];

  return (
    <Flex width="100%" justify="between" align="center" minHeight="58px">
      <Flex style={{ flex: 1 }} align="center">
        {selectedCategory ? (
          <Button onClick={onClearCategory} mode="text" variant="black">
            <BackArrow className="fa-solid fa-chevron-left" />
            {t('allCategories')}
          </Button>
        ) : (
          <Heading size="6" m="0">
            Vault
          </Heading>
        )}
      </Flex>
      {!selectedCategory && (
        <ToggleGroup
          items={viewToggleItems}
          value={activeView}
          onValueChange={onViewToggle}
        />
      )}
      <Flex style={{ flex: 1 }} gap="3" align="center" justify="end">
        {showManageButton && (
          <>
            <RadixButton
              size="3"
              variant="outline"
              onClick={() => setManageOpen(true)}
            >
              <i className="fa-regular fa-gear" />
              {t('manageCategories')}
            </RadixButton>
            <ManageCategoriesModal
              open={manageOpen}
              onOpenChange={setManageOpen}
            />
          </>
        )}
        <UploadFile
          organizationId={organizationId}
          uploadFiles={uploadFiles}
          categories={categories}
          vendors={vendors}
          defaultCategory={selectedCategory}
        />
      </Flex>
    </Flex>
  );
};
